"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComingSoon = void 0;
var React = __importStar(require("react"));
var pinpo_ui_kit_1 = require("pinpo-ui-kit");
var coming_soon_2x_png_1 = __importDefault(require("../../assets/images/coming-soon@2x.png"));
var ComingSoon = function (_a) {
    var className = _a.className, text = _a.text, children = _a.children;
    return (React.createElement("div", { className: "component d-flex flex-column justify-content-center align-items-center " + (className || "min-full-vh") },
        React.createElement("img", { src: coming_soon_2x_png_1.default, alt: "Available Soon", height: 200 }),
        React.createElement("h2", { className: "mt-lg typo-heading-large text-center", style: { color: pinpo_ui_kit_1.Colors.nickel } }, text),
        children));
};
exports.ComingSoon = ComingSoon;
//# sourceMappingURL=ComingSoon.js.map